/**
 * @generated SignedSource<<7322079da08cc0d85efaf6ee42ca36f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_spreadsheetView$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_spreadsheetViewResult" | "topBar_issueNavigator_spreadsheetViewResult">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_spreadsheetView";
};
export type main_issueNavigator_IssueNavigatorUI_spreadsheetView$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_spreadsheetView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_spreadsheetView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_spreadsheetView",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_spreadsheetViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_spreadsheetViewResult"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "d18b9e6b4124d290f0c90ff96efddf04";

export default node;
